const redemption = {
  withdraw: 'Withdraw',
  title: 'Redemption vault',
  amount: 'Amount in vault',
  empty: 'Vault is empty',
  redemptiontitle:'Amount in vault',
  redemptiondetails:'Redemption detail',
  table: {
    amount: 'Amount',
    type: 'Type',
    acc: 'Account details',
    ref: 'Payment ref.',
    date: 'Date paid',
    status: 'Status',
    customer: 'Customer'
  },
  form: {
    title: 'Single tranfer',
    0: {
      label: 'Select account',
      placeholder: 'Select account',
      0: 'Bank transfer',
      1: 'Mobile money',
    },
    1: {
      label: 'Account name',
      placeholder: 'Enter account name'
    },
    2: {
      label: 'Enter amount',
      placeholder: 'Enter amount'
    },
    3: {
      label: 'Description',
      placeholder: 'Type in description'
    },
    4: {
      label: 'Phone number',
      placeholder: 'Enter phone number'
    },
    5: {
      label: 'Network operator',
      placeholder: 'Select network operator'
    },
    submit: 'Proceed'
  },
  otp: {
    explanation: {
     0: 'A 6 digit OTP has been sent to example@gmail.com, enter it to complete transfer',
     1: 'Resent OTP'
    },
    remaining: 'Time remaining',
    input: 'Enter OTP'
  },
  review: {
    'method': 'Payment method',
    'name': 'Account name',
    'number': 'Account number',
    'description': 'Description',
    'amount': 'Amount',
    'total': 'Total',
  }
};

export default redemption;